import { render, staticRenderFns } from "./HomepageView.vue?vue&type=template&id=1b185a1c&"
import script from "./HomepageView.vue?vue&type=script&lang=js&"
export * from "./HomepageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports